export interface AccountPaidThroughClass {
    AccountPaidThroughId: number
    AccountId: number
    PaidThroughAccountName: string
    PaidThroughAccountCode: string
    AccountPaymentMethodGuidId: string
    SystemPaymentAccountTypeId: number
    AccountCurrencyId: number
    Description: string
    CreatedOn: Date | undefined
    CreatedBy: number
    ModifiedOn: Date | undefined
    ModifiedBy: number
    IsDisabled: boolean
    IsDeleted: boolean
    isSelected: number

}

export const paidThroughInitialsForAdd = {
    PaidThroughAccountName: "",
    PaidThroughAccountCode: "",
    AccountPaymentMethodGuidId: "",
    SystemPaymentAccountTypeId: 0,
    AccountCurrencyId: 0,
    Description: "",
    IsDisabled: false
}

export const paidThroughInitialsForUpdate = {
    AccountPaidThroughId: 0,
    PaidThroughAccountName: "",
    PaidThroughAccountCode: "",
    AccountPaymentMethodGuidId: "",
    SystemPaymentAccountTypeId: 0,
    AccountCurrencyId: 0,
    Description: "",
    IsDisabled: false
}